<div class="arrangementContainer" [ngClass]="{'list': isListEdit}">
  @if (!isListEdit) {
    <div class="description">{{ 'arrangement_type' | translate}}:</div>
  }
  @if (currentType === 2) {
    <gl-icon-checkbox
      class="iconCheckbox"
      [checkboxFormGroup]="loadArrangementForm"
      [tooltipInfo]="''"
      [controlName]="'noForm'"
      (click)="noFormChange($event)"
    iconName="noFormIco"></gl-icon-checkbox>
  }
  <gl-icon-checkbox
    class="iconCheckbox"
    [checkboxFormGroup]="loadArrangementForm"
    [tooltipInfo]="''"
    [controlName]="'straight'"
    (click)="straightChange($event)"
    iconName="straightIco"
  ></gl-icon-checkbox>
  <gl-icon-checkbox
    data-ctx="checkbox-honeycomb"
    class="iconCheckbox"
    [checkboxFormGroup]="loadArrangementForm"
    [tooltipInfo]="''"
    [controlName]="'honeycomb'"
    (click)="honeycombChange($event)"
    iconName="honeycombIco"
  ></gl-icon-checkbox>
</div>
